import { USER_ACCESS, USER_TYPES } from "~/shared/api/users/users.constants";
import { TEAM_EXPERIENCE_PREFIX } from "~/team/constants/paths.constants";

export function isBreakLineUser(type: string) {
  return type === USER_TYPES.breakline;
}

export function isParticipantUser(type: string) {
  return type === USER_TYPES.participant;
}

export function isAdminUser(roles?: string[]) {
  return roles?.includes(USER_ACCESS.admin) ?? false;
}

type UserType = keyof typeof USER_TYPES;

export function getRouteTreeRoot(type?: UserType) {
  switch (type) {
    case "breakline": {
      return `/${TEAM_EXPERIENCE_PREFIX}` as const;
    }
    case "participant":
    default: {
      return "/" as const;
    }
  }
}

/**
 * Constructs a share URL based on the user type.
 *
 * @example
 *   buildShareUrl("breakline", "/dashboard"); // Returns "/hq/dashboard"
 *   buildShareUrl("participant", "/dashboard"); // Returns "/dashboard"
 *
 * @param userType - The type of user ('breakline' or 'participant')
 * @param urlPath - The URL path to be appended or prefixed
 * @returns A formatted URL string based on the user type. For 'breakline' users, returns the path prefixed with the
 *   team experience prefix. For 'participant' users, returns the path as-is.
 */
export function buildShareUrl(userType: UserType | undefined, urlPath: string) {
  switch (userType) {
    case "breakline": {
      return `/${TEAM_EXPERIENCE_PREFIX}${urlPath}` as const;
    }
    case "participant":
    default: {
      return `${urlPath}` as const;
    }
  }
}
